import {post,get} from "axios";
import {mapActions} from "vuex";
import store from "../store";
import ElementUI from "element-ui";
import {basementAjax, basementAjaxGet} from "./ajax";
import router from "../router";
import coommonPRAS, {commonPRAS, initFunction} from "./constant";
let Base64 = require('js-base64').Base64
export {//关键
  getCookie, setCookie, deleteCookie,//cookie
  getUrl,
  icreat,
  expireSession,
  getFailure,
  getHeight,
  formatDate,
  formatTime,
  formatTimestamp,
  timeFun,
  formatShortDate,
  addDate,
  isWeekend,
  getWeekend,
  getDiffDay,
  urlencode,
  SecondToDate,
  getUnixTime,
  parseTime,
  previewImage,
  previewSimg,
  clacImgZoomParam,
  b64toFile,
  downloadFileByBase64,
  copyText,
  toThousands,
  exportExcel,
  onkeydown13, downloadFile,
  refreshPermission,
  refreshToken,
  refresh,
  normalizeName
}

/**
 * 规范化名称（客户名、销售名等）：去掉零宽字符/不可见字符，全角空格转普通空格，
 * 压缩连续空白并去除首尾空格。粘贴自外部文档的名称常带不可见字符，
 * 会造成后端与U9/OA的同名拦截失效而重复建档。
 */
function normalizeName(name) {
  if (typeof name !== "string" || name === "") {
    return name;
  }
  return name
    .replace(/[\u200B\u200C\u200D\u2060\uFEFF\u00A0]/g, "")
    .replace(/\u3000/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function getCookie(name, key) {
  var start = document.cookie.indexOf(name + "=");
  var len = start + name.length + 1;
  if ((!start) && (name != document.cookie.substring(0, name.length))) {
    return null
  }
  if (start == -1) {
    return null
  }
  var end = document.cookie.indexOf(';', len);
  if (end == -1) {
    end = document.cookie.length
  }
  var v = unescape(document.cookie.substring(len, end));
  if (key) {
    var keyname = key.split('|');
    var c = v.split('|');
    var vkey = new Array(), newArray = new Array();
    for (var i = 0, vlen = c.length; i < vlen; i++) {
      vkey[i] = c[i].split('=');
      for (var j = 0, klen = keyname.length; j < klen; j++) {
        if (keyname[j] == vkey[i][0]) {
          newArray.push(vkey[i][1])
        }
      }
    }
    return newArray
  } else {
    return v
  }
}

/*所有新增的缓存变量都以下划线开头，并且要MD5加密
 *将name加密 _C450442B63F5B3D2
*/
function setCookie(name, value, expires, path, domain, secure) {
  var today = new Date();
  today.setTime(today.getTime());
  if (expires) {
    expires = expires * 1000 * 60 * 60 * 24
  }
  var expires_date = new Date(today.getTime() + (expires));
  document.cookie = name + '=' + escape(value) + ((expires) ? ';expires=' + expires_date.toGMTString() : '') + ((path) ? ';path=' + path : '') + ((domain) ? ';domain=' + domain : '') + ((secure) ? ';secure' : '')
}

/* function deleteCookie(name, path, domain) {
    if (getCookie(name)){
        console.log("我删cookie");
        document.cookie = name + '=' + ((path) ? ';path=' + path : '') + ((domain) ? ';domain=' + domain : '') + 'max-age=0;expires=Thu, 01-Jan-1970 00:00:01 GMT'
    }
} */
function deleteCookie(name, path) {
  console.log("我删cookie=========" + name);
  var date = new Date();
  date.setTime(date.getTime() - 10000); //删除一个cookie，就是将其过期时间设定为一个过去的时间
  document.cookie = name + "= ' ' " + "; expires=" + date.toUTCString() + ";path=" + ((path) ? ';path=' + path : '');
}

function expireSession(that) {
  if(that){
    that.$message({
      type: "error",
      message: "登录信息失效，请重新登录"
    });
  }else{
    ElementUI.Message.error('登录信息失效，请重新登录')
  }
  const key = process.env.NODE_ENV+"_"+commonPRAS.tag;
  localStorage.removeItem(key+"_"+"accessToken");
  localStorage.removeItem(key+"_"+"refreshToken");
  that.$router.push("/login");
}

function getFailure(that) {
  // localStorage.removeItem("accessToken")
  // that.$router.push("/login");
  // console.log("停止 ",that)

  that.$message({
    type: "error",
    message: "未知错误"
  });
}

//计算table和content高度
function getHeight(otherH, columnH, pageHeight) {
  //计算content高度，ch浏览器的高度 - 头部高度 - content的上下padding
  //计算表格（table）高度，content高度-搜索框的高度-分页高度
  var ch = document.documentElement.clientHeight || document.body.clientHeight;
  var headerH = $(".header").height();
  var conH = ch - headerH - 24 - otherH, tableH = '';
  console.log(headerH)
  // columnH ? tableH = conH - columnH - (pageHeight?pageHeight:0) : '';
  // console.log(columnH)
  tableH = conH - (columnH ? columnH : 0) - (pageHeight ? pageHeight : 0);

  var oHeight = {}
  oHeight.conHeight = conH;
  oHeight.tableHeight = tableH;
  return oHeight
}

//时间格式化
function formatTime(date) {
  var aaaa = new Date(date).toJSON();
  let Y = date.getFullYear() + '-';
  let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
  let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
  let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
}

//日期格式化
function formatDate(date) {
  if (date == null) return "";
  var oDate = new Date(date);
  let Y = oDate.getFullYear() + '-';
  let M = oDate.getMonth() + 1 < 10 ? '0' + (oDate.getMonth() + 1) + '-' : oDate.getMonth() + 1 + '-';
  let D = oDate.getDate() < 10 ? '0' + oDate.getDate() + ' ' : oDate.getDate() + ' ';

  let d = (Y + M + D).replace(' ', '')
  //console.log(d);
  return d;
}

//时间戳-转换成 yyyy-MM-dd HH:mm:ss
function formatTimestamp(date) {
  var date = new Date(date);
  var YY = date.getFullYear() + '-';
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return YY + MM + DD + " " + hh + mm + ss;
}

//时间戳转为yy-mm-dd
function timeFun(unixtimestamp) {
  var unixtimestamp = new Date(unixtimestamp);
  var year = 1900 + unixtimestamp.getYear();
  var month = "0" + (unixtimestamp.getMonth() + 1);
  var date = "0" + unixtimestamp.getDate();
  // var hour = "0" + unixtimestamp.getHours();
  // var minute = "0" + unixtimestamp.getMinutes();
  // var second = "0" + unixtimestamp.getSeconds();
  // console.log(year,month,date)

  return (
    year +
    "-" +
    month.substring(month.length - 2, month.length) +
    "-" +
    date.substring(date.length - 2, date.length)
  );
  //     +
  //" " + hour.substring(hour.length - 2, hour.length) + ":" +
  //minute.substring(minute.length - 2, minute.length) + ":" +
  //second.substring(second.length - 2, second.length);
}

//日期格式化为 yy/MM/dd（年后两位/月/日，如 26/09/24）
function formatShortDate(val) {
  if (!val) return "";
  var oDate = new Date(val);
  if (isNaN(oDate.getTime())) return val;
  var year = String(oDate.getFullYear()).substring(2);
  var month = "0" + (oDate.getMonth() + 1);
  var date = "0" + oDate.getDate();
  return (
    year +
    "/" +
    month.substring(month.length - 2, month.length) +
    "/" +
    date.substring(date.length - 2, date.length)
  );
}

//将日期格式转换成时间戳
function getUnixTime() {
  var date = new Date();
  var time_str = date.getTime().toString();
  return time_str.substr(0, 10);
}

// 日期格式化
function parseTime(time, pattern) {
  // if (arguments.length === 0 || !time) {
  //     return null
  // }
  // const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  // let date
  // if (typeof time === 'object') {
  //     date = time
  // } else {
  //     if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
  //         time = parseInt(time)
  //     } else if (typeof time === 'string') {
  //         time = time.replace(new RegExp(/-/gm), '/');
  //     }
  //     if ((typeof time === 'number') && (time.toString().length === 10)) {
  //         time = time * 1000
  //     }
  //     date = new Date(time)
  // }
  // const formatObj = {
  //     y: date.getFullYear(),
  //     m: date.getMonth() + 1,
  //     d: date.getDate(),
  //     h: date.getHours(),
  //     i: date.getMinutes(),
  //     s: date.getSeconds(),
  //     a: date.getDay()
  // }
  // const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
  //     let value = formatObj[key]
  //     // Note: getDay() returns 0 on Sunday
  //     if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
  //     if (result.length > 0 && value < 10) {
  //         value = '0' + value
  //     }
  //     return value || 0
  // })
  // return time_str
}

//日期，在原有日期基础上，增加days天数，默认增加1天
function addDate(date, plusDays) {
  var dateArray = date.split("-");
  var year = +dateArray[0];
  var month = +dateArray[1];
  var day = +dateArray[2];
  var oriDay = day;
  var secondMonthDays = ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) ? 29 : 28;
  while (plusDays > 0) {
    oriDay = Number(day)
    day = Number(Number(day) + Number(plusDays));
    // day = plusDays;
    console.log(day)
    switch (month) {
      case 4:
      case 6:
      case 9:
      case 11:
        if (day > 30) {
          plusDays -= (30 - oriDay) + 1;
          month++;
          day = 1;
        } else {
          plusDays = 0;
        }
        break;
      case 2:
        if (day > secondMonthDays) {
          plusDays -= (secondMonthDays - oriDay) + 1;
          month++;
          day = 1;
        } else {
          plusDays = 0;
        }
        break;
      default:
        if (day > 31) {
          plusDays -= (31 - oriDay) + 1;
          day = 1;
          month++;
        } else {
          plusDays = 0;
        }
    }
    if (month > 12) {
      month = 1;
      year++;
    }
  }
  let time = year + "-" + month + "-" + day;
  return time;
}

//检查日期是否在周末
function isWeekend(time) {
  let date = new Date(time);
  return date.getDay() === 6 || date.getDay() === 0;
}

//获取当前是星期几
function getWeekend(time) {
  // alert(time);
  let d = time.split('-').join('/')
  let date = new Date(d);
  // alert(date);
  let day = date.getDay();
  // alert(day);

  let weeks = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
  return weeks[day];
}

//计算两个日期之间的天数
function getDiffDay(date1, date2) {
  let totalDays, diffDate;
  let d1 = Date.parse(date1);
  let d2 = Date.parse(date2);
  diffDate = Math.abs(d1 - d2);
  totalDays = Math.ceil(diffDate / (1000 * 3600 * 24));
  return totalDays;
}

function getUrl() {
  var obj = new Object;
  obj.href = window.location.href;
  obj.host = window.location.hostname;
  obj.protocol = document.location.protocol;

  var tmp = window.location.hostname.split('.');
  obj.hostName = tmp[tmp.length - 2] + '.' + tmp[tmp.length - 1];
  obj.port = location.port;
  var temp = obj.href.match(/(.+?)\?(.+)/);
  if (temp == null) {
    var b = obj.href
  } else {
    var b = temp[1]
  }
  obj.page = b.match(/(.+)\/(.+)/)[2];
  if (obj.port) {
    obj.path = b.replace('http://' + obj.host + ':' + obj.port + '/', '').replace('/' + obj.page, '')
  } else {
    obj.path = b.replace('http://' + obj.host + '/', '').replace('/' + obj.page, '')
  }
  if (b != obj.href) {
    var args = temp[2].split("&");
    for (var i = 0, len = args.length; i < len; i++) {
      var arg = args[i].split("=");
      eval('obj.' + arg[0] + '=\'' + arg[1] + '\';')
    }
  }
  return obj
}

function icreat(tagname, args, pnode, sib) {
  var o = document.createElement(tagname);
  if (args) {
    var aa = args.split(','), an = [], i, len;
    for (i = 0, len = aa.length; i < len; i++) {
      an[i] = aa[i].split(':');
      if (an[i][0].toLowerCase() == 'class') {
        o.className = an[i][1]
      } else {
        o.setAttribute(an[i][0], an[i][1])
      }
    }
  }
  sib = sib || null;
  if (pnode && pnode != 'root') {
    pnode.insertBefore(o, sib)
  } else if (pnode && pnode == 'root') {
    document.body.insertBefore(o, sib)
  }
  return o
}

//动态生成链接
function urlencode(clearString) {
  var output = '';
  var x = 0;

  clearString = utf16to8(clearString.toString());
  var regex = /(^[a-zA-Z0-9-_.]*)/;

  while (x < clearString.length) {
    var match = regex.exec(clearString.substr(x));
    if (match != null && match.length > 1 && match[1] != '') {
      output += match[1];
      x += match[1].length;
    } else {
      if (clearString[x] == ' ') {
        output += '+';
      } else {
        var charCode = clearString.charCodeAt(x);
        var hexVal = charCode.toString(16);
        output += '%' + (hexVal.length < 2 ? '0' : '') + hexVal.toUpperCase();
      }
      x++;
    }
  }
  return output;
}

function utf16to8(str) {
  var out, i, len, c;
  out = "";
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if ((c >= 0x0001) && (c <= 0x007F)) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
    } else {
      out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
    }
  }
  return out;
}

//将秒转化为天时分秒
function SecondToDate(msd) {
  var time = msd;
  var final = msd;

  if (null != time && "" != time && undefined != time) {
    let oTime = time / 3600.0;
    // console.log(msd)
    if (time > 60 && time < 60 * 60) {
      let m = time / 60.0;
      final = parseInt(m) + "分钟"
      // let s = (parseFloat(m) - parseInt(m)) * 60;
      // if (s != 0) {
      //     final += parseInt(m) + "分钟"
      // }
      // console.log(final)
      return final;
    } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
      final = parseInt(oTime) + "小时";
      // let m = (parseFloat(oTime) - parseInt(oTime)) * 60;
      // if (m != 0) {
      //     final += parseInt(m) + "分钟";
      // }
      // let s = (parseFloat(m) - parseInt(m)) * 60;
      // if (s != 0) {
      //     final += parseInt(s) + "秒";
      // }
      return final;
    } else if (time >= 60 * 60 * 24) {
      let day = oTime / 24;
      final = parseInt(day) + "天";
      // let h = (parseFloat(day) - parseInt(day)) * 24;
      // if (h != 0) {
      //     final += parseInt(h) + "小时"
      // }
      // let m = (parseFloat(oTime) - parseInt(oTime)) * 60;
      // if (m != 0) {
      //     final += parseInt(m) + "分钟"
      // }
      // let s = (parseFloat(m) - parseInt(m)) * 60;
      // if (s != 0) {
      //     final += parseInt(s) + "秒";
      // }
      return final;
    } else {
      final = parseInt(time) + "秒";
      return final;
    }
  }
}

//上传图片回显并且获取base64
function previewImage(that, file, oDiv) {
  var MAXWIDTH = 400;
  var MAXHEIGHT = 255;
  let aaa = '1';
  // var div = oDiv;
  return new Promise(function (resolve, reject) {
    if (file.files && file.files[0]) {
      // div.innerHTML ='<img id=imghead>';
      var img = oDiv//document.getElementById('imghead');
      img.onload = function () {
        var rect = clacImgZoomParam(MAXWIDTH, MAXHEIGHT, img.offsetWidth, img.offsetHeight);
        img.width = rect.width;
        img.height = rect.height;
        //   img.style.marginTop = rect.top+'px';
      }
      var reader = new FileReader();
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = reader.size / 1024 / 1024 < 2;
      // console.log(reader)
      // if (!isJPG) {
      //     that.$message.error("上传头像图片只能是 JPG 格式!");
      //     return
      // }
      // if (!isLt2M) {
      //     that.$message.error("上传头像图片大小不能超过 2MB!");
      //     return
      // }
      // reader.readAsBinaryString(file.files[0])
      reader.onload = function (evt) {
        // img.src = evt.target.result;
        aaa = evt.target.result;
        resolve(aaa)
      }
      reader.readAsDataURL(file.files[0]);
    } else { //兼容IE
      console.log("gbklhhh")
      var sFilter = 'filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod=scale,src="';
      file.select();
      var src = document.selection.createRange().text;
      //   div.innerHTML = '<img id=imghead>';
      var img = oDiv //document.getElementById('imghead');
      img.filters.item('DXImageTransform.Microsoft.AlphaImageLoader').src = src;
      var rect = clacImgZoomParam(MAXWIDTH, MAXHEIGHT, img.offsetWidth, img.offsetHeight);
      status = ('rect:' + rect.top + ',' + rect.left + ',' + rect.width + ',' + rect.height);
      div.innerHTML = "<div id=divhead style='width:" + rect.width + "px;height:" + rect.height + "px;margin-top:" + rect.top + "px;" + sFilter + src + "\"'></div>";
    }
  })
}

//图片自适应
function clacImgZoomParam(maxWidth, maxHeight, width, height) {
  var param = {top: 0, left: 0, width: width, height: height};
  if (width > maxWidth || height > maxHeight) {
    let rateWidth = width / maxWidth;
    let rateHeight = height / maxHeight;

    if (rateWidth > rateHeight) {
      param.width = maxWidth;
      param.height = Math.round(height / rateWidth);
    } else {
      param.width = Math.round(width / rateHeight);
      param.height = maxHeight;
    }
  }
  param.left = Math.round((maxWidth - param.width) / 2);
  param.top = Math.round((maxHeight - param.height) / 2);
  return param;
}

//上传文件并且获取base64
function previewSimg(file) {
  let aaa = '1';
  // var div = oDiv;
  return new Promise(function (resolve, reject) {
    if (file.files && file.files[0]) {
      // div.innerHTML ='<img id=imghead>';
      var reader = new FileReader();
      // reader.readAsBinaryString(file.files[0])
      reader.onload = function (evt) {
        // img.src = evt.target.result;
        aaa = evt.target.result;
        resolve(aaa)
      }
      reader.readAsDataURL(file.files[0]);

    } else { //兼容IE
      console.log("gbklhhh")
      var sFilter = 'filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod=scale,src="';
      file.select();
      var src = document.selection.createRange().text;
      //   div.innerHTML = '<img id=imghead>';
      var img = oDiv //document.getElementById('imghead');
      img.filters.item('DXImageTransform.Microsoft.AlphaImageLoader').src = src;
      var rect = clacImgZoomParam(MAXWIDTH, MAXHEIGHT, img.offsetWidth, img.offsetHeight);
      status = ('rect:' + rect.top + ',' + rect.left + ',' + rect.width + ',' + rect.height);
      div.innerHTML = "<div id=divhead style='width:" + rect.width + "px;height:" + rect.height + "px;margin-top:" + rect.top + "px;" + sFilter + src + "\"'></div>";
    }
  })
}

//将base64编码转化成excel
function b64toFile(b64Data, filename, contentType) {
  let sliceSize = 512;
  let byteCharacters = atob(b64Data);
  let byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);
    let byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  let file = new File(byteArrays, filename, {type: contentType});
  return file;
}

/**封装blob对象*/
function dataURLtoBlob(base64Str, mimeTypeStr) {
  var bstr = atob(base64Str), n = bstr.length, u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type: mimeTypeStr});
}

/**创建一个a标签，并做下载点击事件*/
function downloadFile(hrefUrl, fileName) {
  var a = document.createElement("a")
  a.setAttribute("href", hrefUrl)
  a.setAttribute("download", fileName)
  a.setAttribute("target", "_blank")
  let clickEvent = document.createEvent("MouseEvents");
  clickEvent.initEvent("click", true, true);
  a.dispatchEvent(clickEvent);


}

/**下载文件的方法*/
function downloadFileByBase64(base64Str, mimeTypeStr, fileName) {
  var myBlob = dataURLtoBlob(base64Str, mimeTypeStr)
  var myUrl = URL.createObjectURL(myBlob)
  downloadFile(myUrl, fileName)
}

//复制文本
function copyText(event) {


  // 一键复制
  // const input = document.createElement("input");
  // input.setAttribute("readonly", "readonly");
  // input.setAttribute("value", data);
  // document.body.appendChild(input);
  // input.select();
  // input.setSelectionRange(0, 9999);

  // if (document.execCommand("copy")) {   // true
  //   document.execCommand("copy");
  //   console.log("复制成功");
  // }
  // document.body.removeChild(input);


  var node = document.createElement('textarea');
  node.value = event;
  node.setAttribute('readOnly', 'readOnly');
  node.setAttribute('style', "position: fixed; left: 0; top: 0;opacity: 0");
  document.getElementsByTagName('body')[0].appendChild(node);
  setTimeout(function () {
    node.focus();
    node.setSelectionRange(0, node.value.length);
    try {
      document.execCommand('copy', true);
    } catch (e) {
    }
    node.parentNode.removeChild(node);
  }, 0);

  // var input = document.createElement("input"); // js创建一个input输入框
  // input.value = text; // 将需要复制的文本赋值到创建的input输入框中
  // document.body.appendChild(input); // 将输入框暂时创建到实例里面
  // input.select(); // 选中输入框中的内容
  // document.execCommand("Copy"); // 执行复制操作
  // document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
}

//格式化金额千位符
function toThousands(num) {
  if (num === null || num === undefined || num === "") return "0";
  const n = Number(num);
  if (!Number.isFinite(n)) return "0";
  const sign = n < 0 ? "-" : "";
  // toFixed(2) 同时解决:
  //   - 整数入参补两位小数 90520 -> '90520.00'
  //   - 字符串小数入参原样保留 '90520.00' -> '90520.00'
  //   - 不足两位补零 90520.5 -> '90520.50'
  //   - 超出两位四舍五入 90520.129 -> '90520.13'
  const fixed = Math.abs(n).toFixed(2);
  const dotIdx = fixed.indexOf(".");
  const intPart = dotIdx === -1 ? fixed : fixed.slice(0, dotIdx);
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const decPart = fixed.slice(dotIdx + 1);
  return `${sign}${grouped}.${decPart}`;
}

/**
 * 导出文件
 * @param {string|Uint8Array} data - 文件内容
 * @param {string} fileName - 文件名称
 * @param {string} type - MIME类型，例如：'text/plain'、'application/octet-stream'
 */
function downloadFile(data, fileName, type) {
  const blob = new Blob([data], {type});
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

//调用方法：exportExcel(接口路径,接口传参,下载文件名,头部信息,回调函数)
function exportExcel(apiUrl, postData, downloadFileName, headers, cb) {
  //apiUrl, postData, downloadFileName, headers, cb（传参说明：接口路径,接口传参,下载文件名,头部信息,回调函数）
  (typeof postData !== 'string') && (postData = JSON.stringify(postData));
  downloadFileName || (downloadFileName = '下载文件.xlsx');//如果.xlsx无法打开就改为.xls后缀名
  let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLDOM');
  console.log(headers)

  xhr.open('POST', apiUrl, true);
  xhr.responseType = 'blob';
  // 这里的header内容根据具体业务来调整参数：
  // xhr.setRequestHeader('cookie', '你的cookie');
  // xhr.setRequestHeader('sessionId', '你的sessionId');
  xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"accessToken")}`);
  xhr.setRequestHeader('Content-Type', headers.contentType || "application/json;Charset:utf-8");
  xhr.setRequestHeader('client-type', "web_techikAsociation");

  // ----------------------------------------
  //发送数据
  xhr.send(postData);
  // ----------------------------------------
  //监控对象变化
  xhr.onreadystatechange = function () {
    if(xhr&&xhr.response&&xhr.response.type&&xhr.response.type==='application/json'){
      cb && cb(false);
      return
    }
    if (xhr.readyState === 4) {
      console.log(xhr)
      if (xhr.status == 200 ) {
        cb && cb(true);//下载成功
        let blobData = xhr.response;
        let reader = new FileReader();
        reader.readAsDataURL(blobData), reader.onload = function (e) {
          let a = document.createElement('a');
          a.download = downloadFileName, a.href = blobData.size < 32767 ? e.target.result : URL.createObjectURL(blobData), a.style.display = 'none';
          document.body.appendChild(a), a.click();
          URL.revokeObjectURL(a.href), document.body.removeChild(a);
        };
      } else {
        cb && cb(false);//下载失败
      }
    }

  };

};

//搜索
function onkeydown13(callback) {
  // o.onkeydown = function(event) {
  document.getElementById("searchForm").onkeydown = function (event) {
    if (event.keyCode == 13) {
      callback();
      // event.stopPropagation();
      console.log("点击了回车")
    }
  };
}

//深拷贝
export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj))
}

//清除对象的value
export function clearObjectValues(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      switch (typeof obj[key]) {
        case 'string':
          obj[key] = '';
          break;
        case 'object':

          if (Array.isArray(obj[key])) {
            obj[key].forEach(item => clearObjectValues(item))
          } else {
            clearObjectValues(obj[key]);
          }
          break;
        case 'number':
          obj[key] = 0;
          break;
        default:
          obj[key] = null;
      }
    }
  }
}


/*千位分隔符*/
export function formatNumber(num) {
  // 先确保数字转换为字符串以便处理
  num = String(num);

  // 通过正则表达式替换千位符号
  num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 获取小数点位置，如果没有小数点，则默认添加'.00'，否则截取至小数点后两位
  var decimalIndex = num.indexOf('.');
  if (decimalIndex === -1) {
    num += '.00';
  } else {
    // 如果小数部分不足两位，则补零
    if (num.length - decimalIndex - 1 < 2) {
      num = num.padEnd(decimalIndex + 3, '0');
    }
  }

  return num;
}

export function isTrueContinuousOrderId(input) {
  if (!input) return true;

  // 修改后的正则表达式
  const regex = /^(?:[A-Za-z0-9]+-\d{1,5}|(\d{1,5}))$|^(\d{1,5})(?:~(\d{1,5}))?$|^([A-Za-z0-9]+-\d{1,5})(?:~([A-Za-z0-9]+-\d{1,5}))?$/;

  // 使用 '、' 分割输入
  const inputs = input.split('、');

  return inputs.every(part => {
    // 检查每个部分是否符合格式
    if (regex.test(part.trim())) {
      const parts = part.split('~');

      // 检查是否为有效的号码
      return parts.every(part => {
        const trimmedPart = part.trim();
        // 验证五位数或前缀-五位数
        return regex.test(trimmedPart);
      }) && isValidSequence(parts);
    }
    return false;
  });
}

// 检查连号的有效性
function isValidSequence(parts) {
  if (parts.length === 1) {
    return true; // 单个号码直接返回true
  }

  const firstMatch = parts[0].trim().match(/^([A-Za-z0-9]+)-(\d{1,5})$/);
  const secondMatch = parts[1].trim().match(/^([A-Za-z0-9]+)-(\d{1,5})$/);

  if (firstMatch && secondMatch) {
    // 如果都是带前缀的号码，比较数字部分
    const firstNum = Number(firstMatch[2]);
    const secondNum = Number(secondMatch[2]);
    return firstNum < secondNum && (secondNum - firstNum <= 50); // 添加差值不超过50的条件
  } else {
    const firstNum = parseInt(parts[0].trim());
    const secondNum = parseInt(parts[1].trim());

    // 处理数字范围，添加差值不超过50的条件
    return firstNum < secondNum && (secondNum - firstNum <= 50);
  }
}
function refreshToken() {
  return new Promise((resolve, reject) => {
    const refreshToken= localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"refreshToken");
    if(!refreshToken){
      //跳转到登录页面
      ElementUI.Message({
        message: '请重新登录',
        type: 'error',
        duration: 3000
      })
      router.push("/login");
      return
    }
    get("/techik/association/auth/refreshToken",  {
      headers: {Authorization: `${refreshToken}`}
    })
      .then(res => {
        //token信息存储到vuex
        const {code, data: {accessToken,refreshToken},message} = res.data
        if (code === 1) {
          //获取当前环境
          const key = process.env.NODE_ENV+"_"+commonPRAS.tag;
          console.log("当前环境key"+ key)
          localStorage.setItem(key+"_"+"accessToken", accessToken);
          localStorage.setItem(key+"_"+"refreshToken", refreshToken);
          initFunction()
          resolve()
        }else{
          ElementUI.Message({
            message: message||'refreshToken到期请重新登录',
            type: 'error',
            duration: 3000
          })
        }
      })
      .catch(error => {
        ElementUI.Message({
          message: error.message,
          type: 'error',
          duration: 3000
        })
        console.log(error)
        reject()
      });
  })

}
function refreshPermission() {
  return new Promise((resolve, reject) => {
    basementAjax(this,"/techik/user/permission",{},(res) => {
      //权限存储到vuex
      console.log(res.data)
      const {code, data: {permissionDTO, productTypes, departmentDtos,username}} = res.data
      console.log(permissionDTO, productTypes, departmentDtos)
      if (code === 1 && null == permissionDTO) {
        ElementUI.Message({
          message: res.message || '权限异常',
          type: 'error',
          duration: 5 * 1000
        })
        return
      }
      store.dispatch("permission/setPermissions", permissionDTO);
      if(JSON.stringify(permissionDTO).includes("超级管理")){
        localStorage.setItem("productTypes",JSON.stringify([
          {"productTypeId": 1, "productTypeCode": "IMD", "receiver": true, "cc": true},
          {"productTypeId": 2, "productTypeCode": "IXL", "receiver": true, "cc": true},
          {"productTypeId": 3, "productTypeCode": "TXR", "receiver": true, "cc": true},
          {"productTypeId": 4, "productTypeCode": "TH", "receiver": true, "cc": true},
          {"productTypeId": 5, "productTypeCode": "TCS", "receiver": true, "cc": true},
          {"productTypeId": 6, "productTypeCode": "TVS", "receiver": true, "cc": true},
          {"productTypeId": 7, "productTypeCode": "HF-TXR", "receiver": true, "cc": true},
        ])) ;
      }else if (productTypes) {
        localStorage.setItem("productTypes", JSON.stringify(productTypes));
      }
      if (departmentDtos) {
        store.dispatch("permission/setDepartments", departmentDtos);
        localStorage.setItem("departmentDtos", JSON.stringify(departmentDtos));
      }
      if (username) {
        localStorage.setItem("username", username);
      }
      resolve()
    },(error)=>{
      console.log(error)
      reject()
    })

  })


}

function refresh() {
  basementAjaxGet(this,"/techik/system/healthCheck",()=>{},()=>{},()=>{})
}



// WEBPACK FOOTER //
// ./src/common/base.js